module.exports = __webpack_public_path__ + "static/morteros-tecnicos.af532fae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/inicio-soluciones/morteros-tecnicos.jpg
// module id = 358
// module chunks = 35783957827783